import React from 'react';
type BadgeTone = 'neutral' | 'coral' | 'success' | 'warning' | 'info' | 'navy';
const tones: Record<BadgeTone, string> = {
  neutral: 'bg-muted text-muted-foreground border-border',
  coral: 'bg-coral/5 text-coral border-coral/20',
  success: 'bg-emerald-50 text-emerald-600 border-emerald-200',
  warning: 'bg-amber-50 text-amber-700 border-amber-200',
  info: 'bg-teal-50 text-foreground border-teal-100',
  navy: 'bg-navy text-white border-transparent'
};
export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}
export function Badge({
  tone = 'neutral',
  className = '',
  children,
  ...props
}: BadgeProps) {
  return <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium border ${tones[tone]} ${className}`} {...props} data-id="element-1150">
      {children}
    </span>;
}